import { FC } from 'react';
import { Box, Heading, Image, Label } from '@alto-avios/alto-ui';

import { OpCoListContent, useRequiredContent } from '../services/content';
import { Button } from '../Button';
import { useUIString } from '../services/content/hooks/useUIString';

import styles from './LoginListMenu.module.css';

import { useHeaderProps } from '#src/contexts/headerProps/useHeaderProps.tsx';

export interface LoginListMenuProps {
  loginUrl?: string;
  onLoginClick: (opcoId: string, isOpCoSupported?: boolean) => void;
}

export const LoginListMenu: FC<LoginListMenuProps> = ({ loginUrl, onLoginClick }) => {
  const { data: opcos } = useRequiredContent(OpCoListContent);
  const { supportedOpCos } = useHeaderProps();
  const isOpCoSupported = (id: string, opcos?: string[]): boolean => (opcos && opcos.length > 0 ? opcos.includes(id) : true);
  const signInDropdownTitle = useUIString('signInDropdownTitle');

  return (
    <Box flexDirection="column" borderRadius="xs" borderWidth="sm" padding="sm" gap="lg" width="285px" backgroundColor="layer2" position="relative">
      <Heading size="xxs">{signInDropdownTitle}</Heading>
      <ul className={styles.list}>
        {opcos?.map(({ label, image, id }) => (
          <li key={label} className={styles.listItem}>
            <Button
              emphasis="quaternary"
              href={isOpCoSupported(id, supportedOpCos) ? loginUrl : `${window.location.origin}/api/auth/login`}
              size="sm"
              styleVariant="neutral"
              fullWidth
              onPress={() => onLoginClick(id, isOpCoSupported(id, supportedOpCos))}
            >
              <span className={styles.logo}>
                <Image src={image.url} alt={image.title} />
              </span>
              <span className={styles.label}>
                <Label size="sm">{label}</Label>
              </span>
            </Button>
          </li>
        ))}
      </ul>
    </Box>
  );
};
